import PropTypes from "prop-types";

function PositivacaoMobile({ app, config }) {
  return <></>;
}

PositivacaoMobile.defaultProps = {
  app: null,
  config: {},
};

PositivacaoMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoMobile;
